module.exports = __webpack_public_path__ + "img/google-white.b894daf1.svg";